export default function AboutUs() {
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div>
            <div className="mb-6 sm:mb-8">
              <span className="text-teal-600 font-semibold text-sm sm:text-base uppercase tracking-wide">
                Sobre Nosotros
              </span>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4 sm:mb-6">
                ¿Quiénes Somos?
              </h2>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-4">
                Somos el <strong>referente en vaciado de pisos en Barcelona</strong> con más de 10 años de experiencia. Una empresa privada especializada en el vaciado profesional de pisos, casas, locales, almacenes y garajes.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-4">
                Nuestro equipo de profesionales cualificados se encarga de todo el proceso, desde la retirada de muebles y enseres hasta la gestión responsable de residuos, para que tú no tengas que preocuparte de nada.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                Trabajamos con <strong>total transparencia</strong>, ofreciendo presupuestos claros sin sorpresas y cumpliendo con todas las normativas medioambientales vigentes.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4 sm:gap-6">
              <div className="bg-teal-50 rounded-xl p-4 sm:p-6">
                <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-teal-600 mb-2">+10</div>
                <div className="text-xs sm:text-sm text-gray-700 font-medium">Años de experiencia</div>
              </div>
              <div className="bg-teal-50 rounded-xl p-4 sm:p-6">
                <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-teal-600 mb-2">+500</div>
                <div className="text-xs sm:text-sm text-gray-700 font-medium">Pisos vaciados</div>
              </div>
              <div className="bg-teal-50 rounded-xl p-4 sm:p-6">
                <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-teal-600 mb-2">100%</div>
                <div className="text-xs sm:text-sm text-gray-700 font-medium">Clientes satisfechos</div>
              </div>
              <div className="bg-teal-50 rounded-xl p-4 sm:p-6">
                <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-teal-600 mb-2">24h</div>
                <div className="text-xs sm:text-sm text-gray-700 font-medium">Respuesta rápida</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl w-full h-[400px] sm:h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/1869b056e086ad27ce87460ecbef1777.jpg"
                alt="Equipo profesional de vaciado de pisos Barcelona"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
                width="800"
                height="533"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white rounded-xl p-6 sm:p-8 shadow-xl max-w-xs hidden sm:block">
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-shield-check-line text-3xl"></i>
                <div className="text-2xl font-bold">100%</div>
              </div>
              <div className="text-sm font-medium">Servicio Asegurado y Certificado</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
